import React from 'react'
import { LuClock } from "react-icons/lu";
import { CiCalendarDate } from "react-icons/ci";
import { BsDatabase, BsFileEarmarkBreak } from "react-icons/bs";
import MessageBox from './MessageBox';
const AdminAudioPlayer = (props) => {
    const { data } = props
    const sourceType = {
        '1': 'Video',
        '5': "Audio",
        '16': "Trailer",
        '17': "substitute"
    }
    return (
        <div>
            <audio key={data?.mp3_url} src={data?.mp3_url} controls className='w-100'>
                Your browser does not support the audio element.
            </audio>
            <div className='d-flex justify-content-between align-items-center mt-4'>
                <div className="d-flex align-items-center gap-2">
                    <LuClock style={{ width: "18px", height: "18px" }} /><MessageBox text={data?.duration || "00:00:00"} />
                </div>
                <div className="d-flex align-items-center gap-2">
                    <CiCalendarDate style={{ width: "18px", height: "18px" }} /><MessageBox text={data?.upload_on || "NA"} />
                </div>
                <div className="d-flex align-items-center gap-2">
                    <BsDatabase style={{ width: "18px", height: "18px" }} /><MessageBox text={['bunny_stream', 'bunny_storage'].includes(data?.uploaded_type) ? 'CDN' : (data?.uploaded_type?.replace(/_/g, " ") || "NA")} />
                </div>
                <div className="d-flex align-items-center gap-2">
                    <BsFileEarmarkBreak style={{ width: "18px", height: "18px" }} /><MessageBox text={sourceType[data?.source_type] || "NA"} />
                </div>
            </div>

        </div>
    )
}

export default AdminAudioPlayer